import type { ReactNode } from "react";

interface Props {
  header: ReactNode;
  action?: ReactNode;
  children: ReactNode;
}

export function SectionCard({ header, action, children }: Props) {
  return (
    <section>
      <div className="bg-white rounded-3xl border border-neutral-100 shadow-sm overflow-hidden">
        <div className="px-6 py-4 border-b border-neutral-50 bg-neutral-50/30 flex items-center justify-between">
          <div className="text-[10px] font-bold text-neutral-400 uppercase tracking-widest flex items-center gap-2">
            {header}
          </div>
          {action}
        </div>
        <div className="p-8">{children}</div>
      </div>
    </section>
  );
}
